import z from 'zod'
import type { SCIDAccountProfile, SCIDShopItem } from './scid'
// Copied from '@adyen/api-library/lib/src/typings/checkout/storedPaymentMethod'
export interface StoredPaymentMethod {
  brand?: string
  expiryMonth?: string
  expiryYear?: string
  holderName?: string
  iban?: string
  id?: string
  lastFour?: string
  name?: string
  networkTxReference?: string
  ownerName?: string
  shopperEmail?: string
  supportedShopperInteractions?: Array<string>
  type?: string
  discriminator: string | undefined
  attributeTypeMap: Array<{
    name: string
    baseName: string
    type: string
  }>
  getAttributeTypeMap(): {
    name: string
    baseName: string
    type: string
  }[]
}

export const billingAddressSchema = z.object({
  address: z.string().optional(),
  postalCode: z.string().optional(),
  city: z.string().optional(),
  country: z.string().optional(),
  stateOrProvince: z.string().optional(),
})

export type BillingAddress = z.infer<typeof billingAddressSchema>

export interface Profile {
  profile: SCIDAccountProfile & { isCreator: boolean; billingAddress?: BillingAddress }
  inventory: {
    items: SCIDShopItem[]
  }
}
